// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-default.section-default--column{display:flex;flex-direction:column}.section-default--column .subheadline{font-size:1.25rem}.section-default--column .section-default.section-default--product .content--image-left,.section-default--column .section-default.section-default--product .content--image-right{flex-direction:column-reverse}.section-default--column .section-default.section-default--product .visual{margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
